
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title: "Les extensions d'annonces Google Ads : guide pour bien choisir",
    description:
      "Apprenez à utiliser et optimiser les extensions d'annonces Google Ads pour améliorer vos campagnes. Suivez les conseils experts d'ALEO pour de meilleurs résultats.",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
